// FILE PATH: eRFQFrontend/src/component/Vendor/LogisticViewRFQ/ViewLogisticRFQDetails.jsx

import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const getExchangeRateForItem = (item, currencyArray) => {
  if (
    item?.exchangeRate !== undefined &&
    item?.exchangeRate !== null &&
    item?.exchangeRate !== ""
  ) {
    return item.exchangeRate;
  }

  const matchedCurrency = currencyArray.find(
    (currency) => currency?.name === item?.currency,
  );
  return matchedCurrency?.rate ?? "-";
};

const parseDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

const isWithin = (start, end) => {
  const startDate = parseDate(start);
  const endDate = parseDate(end);
  const now = new Date();

  if (!startDate && !endDate) return true;
  if (startDate && now < startDate) return false;
  if (endDate && now > endDate) return false;
  return true;
};

const ViewLogisticRFQDetails = () => {
  const { logisticDraftId } = useParams();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const vendorId = JSON.parse(localStorage.getItem("vendor"));

  const [rfq, setRfq] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getRFQ = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic/get-by-id?vendorId=${vendorId}&logisticDraftId=${logisticDraftId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setRfq(res.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getRFQ();
  }, [logisticDraftId]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!rfq) return <div style={{ padding: 40 }}>RFQ not found.</div>;

  const currencyArray = Array.isArray(rfq.currencies) ? rfq.currencies : [];
  const workItems = Array.isArray(rfq.workItems) ? rfq.workItems : [];

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "end", gap: 50 }}>
        {(["BID_CLOSED", "BID_SUBMITTED", "REBID", "AWARDED"].includes(
          rfq?.vrStatus,
        ) ||
          (rfq?.vrStatus === "DISQUALIFIED" &&
            rfq?.stage !== "FINANCE_HEAD" &&
            rfq?.stage !== "BUYER")) && (
          <div
            className="tender-card"
            style={{
              background: "#EFE6F6",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(
                `/vendor/logistic-dashboard/${logisticDraftId}/view-quote`,
              )
            }
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <div
                style={{
                  borderRadius: "50%",
                  background: "#fff",
                  padding: "10px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <ShowChartIcon />
              </div>
            </div>
            <Typography fontWeight={600}>View Quotes Submitted</Typography>
          </div>
        )}
        <div
          className="tender-card"
          style={{
            background: "#FCEAE4",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/vendor/logistic-dashboard/${logisticDraftId}/view-query`)}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <div
              style={{
                borderRadius: "50%",
                background: "#fff",
                padding: "10px",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <DescriptionOutlinedIcon />
            </div>
          </div>
          <Typography fontWeight={600}>Queries</Typography>
        </div>
      </div>
      <Box className="dashboard-container" px={10}>
        <Typography className="form-title">Logistics RFQ Details</Typography>

        <Grid2 container>
          {[
            { label: "Logistics RFQ ID", value: rfq.logisticDraftId },
            { label: "Mode of Consignment", value: rfq.modeOfConsignment },
            { label: "Consignee", value: rfq.consignee },
            { label: "Invoice No", value: rfq.invoiceNo },
            {
              label: "Transit Time",
              value: rfq.transitTime ? `${rfq.transitTime} Days` : "N/A",
            },
            { label: "No of Pallets", value: rfq.noOfPallets },
            { label: "Address", value: rfq.address },
            { label: "Origin", value: rfq.origin },
            { label: "Destination", value: rfq.destination },
            {
              label: "Gross Weight",
              value: rfq.grossWeight ? `${rfq.grossWeight} KG` : "N/A",
            },
            {
              label: "Dimensions (L x B x H)",
              value: `${rfq.length || 0} x ${rfq.breadth || 0} x ${rfq.height || 0} inches`,
            },
            { label: "Volume CBM", value: rfq.volumeCBM },
          ].map((row, idx) => (
            <React.Fragment key={idx}>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderTop: idx === 0 ? "1px solid #000" : undefined }}
              >
                {row.label}
              </Grid2>

              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                  borderTop: idx === 0 ? "1px solid #000" : undefined,
                }}
              >
                {row.value || "-"}
              </Grid2>
            </React.Fragment>
          ))}
        </Grid2>
      </Box>

      {currencyArray.length > 0 && (
        <>
          <h2>Currency Exchange Rates</h2>

          <Box className="dashboard-container" px={10}>
            <table
              border={1}
              style={{
                borderCollapse: "collapse",
                width: "100%",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "20px" }}>Currency</th>
                  <th>Exchange Rate</th>
                </tr>
              </thead>

              <tbody>
                {currencyArray.map((c, idx) => (
                  <tr key={idx} style={{ textAlign: "center" }}>
                    <td style={{ padding: "20px" }}>{c.name}</td>
                    <td>{c.rate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </>
      )}

      {workItems.length > 0 && (
        <>
          <h2>Work Items</h2>

          <Box className="dashboard-container" px={10}>
            <table
              border={1}
              style={{
                borderCollapse: "collapse",
                width: "100%",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "20px" }}>#</th>
                  <th>Particulars</th>
                  <th>UOM</th>
                  <th>Quantity</th>
                  <th>Currency</th>
                  <th>Exchange Rate</th>
                </tr>
              </thead>

              <tbody>
                {workItems
                  .sort((a, b) => (a.itemOrder ?? 0) - (b.itemOrder ?? 0))
                  .map((item, idx) => (
                    <tr key={idx} style={{ textAlign: "center" }}>
                      <td style={{ padding: "20px" }}>
                        {item.itemOrder ?? idx + 1}
                      </td>
                      <td>{item.particulars || "-"}</td>
                      <td>{item.unit || "-"}</td>
                      <td>{item.quantity}</td>
                      <td>{item.currency || "-"}</td>
                      <td>{getExchangeRateForItem(item, currencyArray)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </Box>
        </>
      )}

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button
          className="btn-outlined"
          onClick={() => navigate("/vendor/logistic-dashboard")}
        >
          Back
        </Button>

        {/* {rfq.vrStatus === "BID_SUBMITTED" && (
          <Button
            className="btn-outlined"
            onClick={() =>
              navigate(
                `/vendor/logistic-dashboard/${logisticDraftId}/view-quote`,
              )
            }
          >
            View Quote
          </Button>
        )} */}
      </Box>
    </div>
  );
};

export default ViewLogisticRFQDetails;
